import React, { useState, useEffect } from "react";
import MyLodder from "../components/lodder";
import MyModal from "../components/session_expired"
import card from "../assets/svg/card.png"
import success from "../assets/svg/bankSuccess.png"
import fileUpload from '../assets/svg/fileUpload.png'
import successIcon from '../assets/svg/success.svg'
import errorIcon from '../assets/svg/error.svg'
import MsgIcon from '../assets/svg/alert.gif'
import styles1 from '../components/dashboard/AddFunds.module.css';
import {
  Typography,
  Modal,
  Checkbox,
  Tab,
  Tabs,
  Container,
  Paper,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Radio,
  Grid,
  Autocomplete,
  TextField,
  FormHelperText,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
  FormGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  Divider,
  Slide,
} from "@mui/material";
import { useAppData } from "../redux/appDataProvider";
import styles from "./Request.module.css";
import ApiClient from '../utilities/apiClient';
import EditIcon from "@mui/icons-material/Edit";
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material";
import image from "../assets/svg/request.png";
import { color, maxHeight, padding, useMediaQuery } from "@mui/system";
import { MuiOtpInput } from "mui-one-time-password-input";
import AppConfig from "../AppConfig";
import VisibilityIcon from "@mui/icons-material/Visibility" // srini - (07-04-25)
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useLocation } from "react-router-dom";
import gpay from "../assets/svg/gpay.png"
import phonepe from "../assets/svg/phonepe.png"
import paytm from "../assets/svg/paytm.png"
import banKicon from "../assets/svg/bankicon.svg"
import backBtn from "../assets/svg/back.png"
import { setOptionSelect, setAddBankToTrue, setOpenModelToTrue, setOpenModelToFalse, setMobileOptionSelected, setLoaderScreenToTrue, resetBankStates, setRpdMsgModelToTrue, setRpdMsgModelToFalse, setRpdError, setRpdHitToFalse, setRpdHitToTrue, setTimeLeft, resetTimeLeft, setId, setFirstRender, setQrLink, setWebTimeLeft, resetWebTimeLeft, setWebRpdHitToTrue, setWebRpdHitToFalse, setPrimaryChosen } from "../redux/authSlice"
import { QRCode } from 'react-qrcode-logo'
import { Shield, Clock, Star, X, AlertCircle, CheckCircle } from "lucide-react";
const TxtField = styled(TextField)(({ theme }) => ({
  input: { color: "#000000" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#000000",
  },
  marginTop: "10px",
  width: "350px",
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "#000000", // use the original border color on hover
    },
  },
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
}));
const Request = () => {
  const isSmallScreen = useMediaQuery("(max-width : 600px)");
  const options = [{ label: "Bank Account", id: "Bank Account" }];
  const isTabNMobile = useMediaQuery("(max-width : 1000px)")
  const location = useLocation();
  const handleSegment = (event, newValue) => {
    console.log(newValue);
    setOption(newValue.id);
  };
  const { optionSelected, apiToken, addBank, openModel, mobileOptionSelected, loaderScreen, timeLeft, openRpdModel, rpdError, rpdHit, email, mobile, userId, id, isFirstRender, qrLink, webTimeLeft, webRpdHit, primaryChosen } = useSelector(state => state.auth)
  const dispatch = useDispatch();

  const [showBankAcc, setShowBankAcc] = React.useState(false); // srini - (07-04-25)
  const [showmodal, setShowModal] = useState(false);
  const [showlodder, setShowLodder] = useState(false)
  const [value, setValue] = useState(0);
  const [bankAccNo, setBankAccNo] = useState("");
  const [bankAccNo1, setBankAccNo1] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [bankUpi, setBankUpi] = useState("");
  const [radio, setRadio] = useState("sms");
  const [dialog, setDialog] = useState(false)
  const [dialogTwo, setDialogTwo] = useState(false)
  const [dialogThree, setDialogThree] = useState(false)
  const [primary, setPrimary] = useState(false);
  const [baError, setBaError] = useState(false);
  const [ba1Error, setBa1Error] = useState(false);
  const [ifscError, setIfscError] = useState(false);
  const [bankUpiError, setBankUpiError] = useState(false);
  const [bankUpiValidationMsg, setBankUpiValidationMsg] = useState("");
  const [match, setMatch] = useState(false);
  const [option, setOption] = useState("Bank Account");
  const [selectedOption, setSelectedOption] = useState("Bank Account");
  const [mobileSelectedOption, setMobileSelectedOption] = useState("PhonePe");
  const [modal, setModal] = useState(false);
  const [error, setError] = useState("")
  const [isEditBankAcc, setIsEditBankAcc] = useState(false);
  const [editBankAccIndex, setEditBankAccIndex] = useState(null)
  const [addBankType, setAddBankType] = useState("RPD")
  const { userBanks, setuserBanks } = useAppData();
  const { userInfo, setUserInfo } = useAppData()
  const [rpdErrorModal, setRpdErrorModal] = useState(false);
  const [image, setImage] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("")
  const [bankVerStats2, setBankVerStats2] = useState([])
  const screen1000px = useMediaQuery('(max-width : 1000px)')
  const [errorModal,setErrorModal]=useState(false)
  const [successModal,setSuccessModal]=useState(false)
  const CustomRadio = styled(Radio)(({ theme }) => ({
    padding: 0,                      // remove default padding
    marginLeft: 0,                       // remove extra spacing
    // minWidth: "unset !important",
    "& .MuiButtonBase-root": {
      padding: "8px", // Adjust padding for spacing
    },

    "& .MuiSvgIcon-root": {
      width: "24px", // Outer circle size
      height: "24px",
      borderRadius: "50%",
      border: "1px solid #000", // Black border for outer circle
      backgroundColor: "#fff", // Default background
    },

    "& .MuiSvgIcon-root path": {
      display: "none", // Hides the default inner dot
    },



    "&.Mui-checked .MuiSvgIcon-root": {
      color: "#F3D45E", // Yellow fill for checked state
      borderRadius: "50%",
      border: "1px solid #000", // Keeps outer black border when checked
      width: 24,
      height: 24,
      transition: "all 0.3s ease", // Smooth transition
    },

    "&.Mui-checked .MuiSvgIcon-root path": {
      display: "block", // Ensure the inner dot is visible when checked
      fill: "#F3D45E", // Make the inner dot yellow
      transform: "scale(1.5)", // Makes the inner circle 50% bigger
      transformOrigin: "center",
    },

    // Media queries for responsiveness
    "@media (max-width: 780px)": {
      "& .MuiSvgIcon-root": {
        width: 24,
        height: 24,
      },
      "&.Mui-checked .MuiSvgIcon-root": {
        width: 24,
        height: 24,
      },
    },

  }));



  const paymentIcons = {
    PhonePe: "/phonepe.svg",
    GPay: "/gpay.svg",
    Paytm: "/paytm.svg",
  };

  useEffect(() => {
    console.log("First render", isFirstRender)
    if (isFirstRender) {
      console.log("🔥 First render of this page");
      dispatch(setFirstRender());
      dispatch(resetBankStates())
    }
  }, [isFirstRender, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  console.log("hheelloee", rpdHit,qrLink)
  console.log("payment Id", id)
  const intervalRef = React.useRef(null);
  const hadLeftRef = React.useRef(false);
  const returnLockRef = React.useRef(false);
  const idRef = React.useRef(null);

  useEffect(() => {
    if (id) {
      idRef.current = id;
      console.log("Updated idRef 👉", idRef.current);
    }
  }, [id]);

  useEffect(() => {
    if (rpdHit && isTabNMobile) {
      if (timeLeft <= 0) {
        console.log("✅✅", timeLeft)
        handleGetBankDetailsForMobile(true)
        dispatch(setRpdHitToFalse())
        return;
      } // stop if expired
      const timer = setInterval(() => {
        dispatch(setTimeLeft());
      }, 1000);
      return () => clearInterval(timer); // cleanup
    }
  }, [timeLeft, rpdHit]);


  const WebintervalRef = React.useRef(null);
  const timerRef = React.useRef(null);

  useEffect(() => {
    if (webRpdHit && !isTabNMobile) {

      // decrease timer every second
      timerRef.current = setInterval(() => {
        dispatch(setWebTimeLeft());
      }, 1000);

      // first API call after 5 sec
      const firstTimeout = setTimeout(() => {
        handleGetBankDetails(false);
        console.log("5️⃣")

        // then call every 3 sec
        WebintervalRef.current = setInterval(() => {
          handleGetBankDetails(false);
          console.log("3️⃣")
        }, 3000);

      }, 5000);

      return () => {
        clearTimeout(firstTimeout);
        if (WebintervalRef.current) clearInterval(WebintervalRef.current);
        if (timerRef.current) clearInterval(timerRef.current);
      };
    }
  }, [webRpdHit, isTabNMobile]);

  useEffect(() => {
    if (webTimeLeft === 0 && webRpdHit && !isTabNMobile) {
      handleGetBankDetails(true);
      console.log("0️⃣")
      dispatch(setWebRpdHitToFalse());
    }
  }, [webTimeLeft]);



  // React.useEffect(() => {
  //   // alert("hello")
  //   if (!location.search) return;
  //   const value = location.search.substring(1);
  //   if (value.includes("timedOut")) {
  //     console.log("inside timeout")
  //     dispatch(setRpdError("Your session has expired. Please try again."))
  //   } else if (value.includes("success=true")) {
  //     console.log("inside success true")
  //     dispatch(setRpdError(""))
  //     handleGetBankDetails()
  //   } else {
  //     console.log("inside success false")
  //     dispatch(setRpdError("Something went wrong. Please try again."))
  //   }
  //   console.log("value:", value);
  //   const baseUrl = window.location.origin + window.location.pathname;
  //   window.history.replaceState({}, document.title, baseUrl);

  // }, [location.search])

  useEffect(() => {
    if (!(rpdHit && isTabNMobile)) return;

    const runLogic = () => {
      dispatch(setTimeLeft());
      console.log("API CALL ✅");
      handleGetBankDetailsForMobile(false);
    };

    const startPolling = () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        console.log("inside runLogic")
        runLogic();
      }, 5000);
    };

    const stopPolling = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    // 🔥 Prevent double return events (focus + visibility)
    const handleReturnOnce = () => {
      if (!hadLeftRef.current) return;          // not left yet
      if (returnLockRef.current) return;        // already handled

      returnLockRef.current = true;             // lock future triggers
      setTimeout(() => (returnLockRef.current = false), 300); // unlock after 300ms

      runLogic();     // immediate API call
      startPolling(); // restart 5-sec polling
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("User left (hidden) 👋");
        hadLeftRef.current = true;
        stopPolling();
      } else {
        console.log("Visibility: user returned");
        handleReturnOnce();
      }
    };

    const handleWindowBlur = () => {
      console.log("Window blur (left) 👋");
      hadLeftRef.current = true;
      stopPolling();
    };

    const handleWindowFocus = () => {
      console.log("Window focus (possible return)");
      handleReturnOnce();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("blur", handleWindowBlur);
    window.addEventListener("focus", handleWindowFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("blur", handleWindowBlur);
      window.removeEventListener("focus", handleWindowFocus);
      stopPolling();
    };
  }, [rpdHit, isTabNMobile]);

  useEffect(() => {
    if (isTabNMobile) {
      dispatch(setOptionSelect("RPD"))
    }
  }, [isTabNMobile])


  const handleFetchBankStatus = async () => {
    try {
      const apiClient = new ApiClient(apiToken);

      const response = await apiClient.fetchData(
        AppConfig.api.Request.bankVerStats,
        "GET",
        null,
        { client_id: userInfo.CLIENT_ID || localStorage.getItem('userid') }
      );

      if (response.status === 200 && response.data.success) {
        console.log("✅✅",response?.data?.data)
        setBankVerStats2([response.data.data]);
      } else if (response.status >= 400) {
        console.error("Server error:", response.data.message)
      }

    } catch (error) {
      console.error("Network or unexpected error:", error)
    }
  }

  useEffect(() => {
    if (userInfo.CLIENT_ID) {

      handleFetchBankStatus()
    }
  }, [userInfo.CLIENT_ID])

  const handleClose = () => {
    setModal(false);
    setBaError(false);
    setBa1Error(false);
    setIfscError(false);
    setMatch(false);
    setIfscCode("");
    setBankAccNo("");
    setBankAccNo1("");
    setPrimary(false)
    setIsEditBankAcc(false);
    setEditBankAccIndex(null)
    // reseting field value - 19-07-24 -Dev Srini
    setBankUpi("")
    setBankUpiError(false)
    dispatch(setAddBankToTrue())
    dispatch(setOpenModelToFalse())
    if (isTabNMobile) {
      setMobileSelectedOption("PhonePe")
      dispatch(setOptionSelect("RPD"))
    } else {
      setAddBankType("RPD")
    }
    dispatch(setRpdError(""))
    dispatch(setRpdHitToFalse())
    dispatch(setWebRpdHitToFalse())
    dispatch(resetTimeLeft())
    dispatch(resetWebTimeLeft())
    dispatch(setPrimaryChosen(false))
  };

  const handleAddBankAccount = () => {
    dispatch(setOpenModelToTrue())
  };

  const handleSubmit = () => {
    setSelectedOption(option);
  };

  const handleEditBankAcc = (i, upi) => {
    setIsEditBankAcc(!isEditBankAcc);
    setModal(true)
    setEditBankAccIndex(i)
    setBankUpi(upi)
  };


  // Regular expression to validate UPI ID format
  const upiIdRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/;

  const runvalidators = () => {


    console.log(bankAccNo.trim().length, "b");
    if (bankAccNo.trim().length === 0) {
      setBaError(true);
    } else {
      setBaError(false);
    }
    if (bankAccNo1.trim().length === 0) {
      setBa1Error(true);
    } else {
      setBa1Error(false);
    }
    if (ifscCode.trim().length === 0) {
      setIfscError(true);
    } else {
      setIfscError(false);
    }

    if (bankUpi.trim().length === 0) {
      setBankUpiError(true);
      setBankUpiValidationMsg("Enter Bank UPI id");
    } else if (!upiIdRegex.test(bankUpi.trim())) {
      setBankUpiError(true);
      setBankUpiValidationMsg("Invalid UPI format");
    } else {
      setBankUpiError(false);
    }

    if (bankAccNo !== bankAccNo1) {
      setMatch(true);
    } else {
      setMatch(false);
    }
  };



  const handleFormSubmit = (e) => {
    runvalidators();
    const exists = userBanks?.some(item => item.Bank_AcNo === bankAccNo?.trim());
    if(exists){
      setError(`This Bank Account already exists`)
      handleClose()
      setDialog(true)
      return
    }
    if (bankUpi.length > 0) {
      if (
        bankAccNo.trim().length > 0 &&
        bankAccNo1.trim().length > 0 &&
        bankAccNo == bankAccNo1 &&
        ifscCode.trim().length > 0 &&
        upiIdRegex.test(bankUpi)
      ) {
        setShowLodder(true)
        console.log(primary, "primary")
        try {
          const apiClient = new ApiClient(apiToken);
          apiClient.fetchData(AppConfig.api.Request.addBank,
            "POST",
            {
              "client_id": userInfo.CLIENT_ID,
              "accno": bankAccNo.trim(),
              "ifsc": ifscCode.trim(),
              "upi": bankUpi.trim(),
              "mobile_number": userInfo.MOBILE_NO,
              "email": userInfo.CLIENT_ID_MAIL,
              "default": primary ? "Yes" : "No"
            }
          ).then((response) => {
            // if(response===401){setShowModal(true)}
            if (response?.status === 200 && response?.data?.Success === "False" && response?.data?.["Error Code"] == "verification" && response?.data?.["Error Description"]?.includes("currently pending")) {
              setShowLodder(false)
              setError('The account you are trying to add has already been submitted and is currently pending verification.')
              handleClose()
              setErrorModal(true)
            }

            else if (response?.status === 200 && response?.data?.Success === "True" && response?.data?.["Success Description"] == "Bank Added Successfully") {
              setError('Bank Account Added Successfully')
              handleClose()
              setSuccessModal(true)
            }

            else if (response?.data?.status === 401 && response.data.data["Error Code"] == "Name Miss Match") {
              handleFetchBankStatus()
              handleClose()
              // setError(response.data.data["Error Description"])
              // setDialog(true)
              setDialogTwo(true)
            }

            else if (response?.data?.status === 403 && response?.data?.data["Error Code"] == "verification") {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            else if (response?.data?.status === 401 && response?.data?.data["Error Code"] == "invalid UPI") {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "INVALID_ACCOUNT_NUMBER")) {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            //added by dev-Ayush to handle Upstream error case
            else if ((response.data.status === 401 && response.data.data["Error Code"] == "UPSTREAM_ERROR")) {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "INVALID_IFSC_CODE")) {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "verification") || (response?.data?.error == "Internal Server Error")) {
              setError('Bank Verification Failed, Please check if the IFSC CODE and Bank Account No. is correct')
              handleClose()
              setDialog(true)
            }

          else if (response?.status === 200 && response?.data?.ledgerData?.status === 500 && response?.data?.ledgerData?.data["Error Description"].includes("already Exist")) {
              setError(`This Bank Account already exists`)
              handleClose()
              setDialog(true)
            }else{
              setShowLodder(false)
              setError('Something went wrong.Please try again later')
              handleClose()
              setErrorModal(true)
            }
          })
            .catch((error) => {
              handleClose()
              setDialog(true)
              setError("Something went wrong")
              console.log(error);
            });
        } catch (error) {
          handleClose()
          setDialog(true)
          setError("Something went wrong")
          console.error('Error verifying bank details:', error);
        }
      }
    } else {
      if (
        bankAccNo.trim().length > 0 &&
        bankAccNo1.trim().length > 0 &&
        bankAccNo == bankAccNo1 &&
        ifscCode.trim().length > 0
      ) {
        setShowLodder(true)
        console.log(primary, "primary")
        try {
          const apiClient = new ApiClient(apiToken);
          apiClient.fetchData(AppConfig.api.Request.addBank,
            "POST",
            {
              "client_id": userInfo.CLIENT_ID || localStorage.getItem('userid'),
              "accno": bankAccNo,
              "ifsc": ifscCode,
              "mobile_number": userInfo.MOBILE_NO,
              "email": userInfo.CLIENT_ID_MAIL,
              "default": primary ? "Yes" : "No"
            }
          ).then((response) => {
            // if(response===401){setShowModal(true)}


            if (response?.status === 200 && response?.data?.Success === "False" && response?.data?.["Error Code"] == "verification" && response?.data?.["Error Description"]?.includes("currently pending") ){
              setError('The account you are trying to add has already been submitted and is currently pending verification.')
              setShowLodder(false)
              handleClose()
              setErrorModal(true)
            }

            else if (response?.data?.status === 403 && response?.data?.data["Error Code"] == "verification") {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            else if (response?.status === 200 && response?.data?.Success === "True" && response?.data?.["Success Description"] == "Bank Added Successfully") {
              setError('Bank Account Added Successfully')
              handleClose()
              setSuccessModal(true)
            }

           else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "UPSTREAM_ERROR")) {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

           else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "INVALID_ACCOUNT_NUMBER")) {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }

            else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "INVALID_IFSC_CODE")) {
              setError(response.data.data["Error Description"])
              handleClose()
              setDialog(true)
            }
            // Name miss error handled - dev Srini - (12-03-25)
            else if (response?.data?.status === 401 && response?.data?.data["Error Code"] == "Name Miss Match") {
              handleFetchBankStatus()
              handleClose()
              // setError(response.data.data["Error Description"])
              // setDialog(true)
              setDialogTwo(true)
            }

            else if ((response?.data?.status === 401 && response?.data?.data["Error Code"] == "verification") || (response.data.error == "Internal Server Error")) {
              setError('Bank Verification Failed, Please check if the IFSC CODE and Bank Account No. is correct')
              handleClose()
              setDialog(true)
            }

            else if (response?.status === 200 && response?.data?.ledgerData?.status === 500 && response?.data?.ledgerData?.data["Error Description"].includes("already Exist")) {
              setError(`This Bank Account already exists`)
              handleClose()
              setDialog(true)
            } else {
              setShowLodder(false)
              setError('Something went wrong.Please try again later')
              handleClose()
              setErrorModal(true)
            }
          })
            .catch((error) => {
              handleClose()
              setDialog(true)
              setError("Something went wrong")
              console.log(error);
            });
        } catch (error) {
          handleClose()
          setDialog(true)
          setError("Something went wrong")
          console.error('Error verifying bank details:', error);
        }
      }
    }
  };

  const handleEditFormSubmit = (e) => {
    runvalidators();
    if (
      userBanks[editBankAccIndex].Bank_AcNo &&
      userBanks[editBankAccIndex].IFSC_CODE_ACT &&
      upiIdRegex.test(bankUpi)
    ) {
      setShowLodder(true)
      console.log(primary, "primary")
      try {
        const apiClient = new ApiClient(apiToken);
        apiClient.fetchData(AppConfig.api.Request.editBank,
          "POST",
          {
            "client_id": userInfo.CLIENT_ID || localStorage.getItem('userid'),
            "accno": userBanks[editBankAccIndex].Bank_AcNo,
            "ifsc": userBanks[editBankAccIndex].IFSC_CODE_ACT,
            "upi": bankUpi.trim(),
            "default":userBanks[editBankAccIndex].Default_Ac == "Yes" ? "Yes" : primary ? "Yes" : "No"
          }
        ).then((response) => {
          console.info(response.data)
          // if(response===401){setShowModal(true)}
          if (response.data.Success == "True") {
            setError('Bank Upi Added Successfully')
            setDialog(true)
            setModal(false)
            setBankUpi("")
            setIsEditBankAcc(false)
            setBaError(false)
            setBa1Error(false)
            setIfscError(false)
            // reseting error vlaue - 19-07-24 -Dev Srini
            setBankUpiError(false)
          }
          if ((response.data.data.Success == "False")) {
            setBankUpiError(true);

            setBankUpiValidationMsg(response.data.data["Error Description"]);
            setShowLodder(false)
          }
          console.log(response.data.data["Error Description"], "Error Description")
        })
          .catch((error) => {
            setBankUpiError(true);
            setBankUpiValidationMsg("Something went wrong");
            setShowLodder(false)
            console.log('Error verifying bank details: ', error);
          });
      } catch (error) {
        setBankUpiError(true);
        setBankUpiValidationMsg("Something went wrong");
        setShowLodder(false)
        console.error('Error verifying bank details: ', error);
      }
    }
  };

  const handleFileUpload = () => {
    setDialogTwo(true)
    setError("")
  }

  const handleFileChange = (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
      return;
    }

    const file = e.target.files[0]

    const fileType = file.type
    const fileSizeMB = file.size / (1024 * 1024)

    if (!file) {
      setSelectedFileName("")
      setImage(null)
      setError(`Please select file`)
      return
    }

    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
      setImage(null)
      setSelectedFileName("")
      setError(`Only JPEG or PNG images are allowed.`)
      return
    }

    if (fileSizeMB > 5) {
      setImage(null)
      setSelectedFileName("")
      setError('Image size must be 5MB or less.')
      return
    }

    setError("")
    setSelectedFileName(file.name)
    setImage(file)
  }

  const handleUploadToS3 = async () => {
    if (!image) {
      setError(`Please select required file`)
      return
    }

    const formData = new FormData()

    formData.append('client_id', userInfo.CLIENT_ID || localStorage.getItem('userid'))
    formData.append('mobile_no', userInfo.MOBILE_NO)
    formData.append('file', image)

    try {
      const apiClient = new ApiClient(apiToken);

      const fileRes = await apiClient.fetchData(AppConfig.api.Request.bankFileUpld,
        "POST",
        formData
      )

      const { status, data } = fileRes

      if (status === 200 && data.success) {
        setImage(null)
        handleFetchBankStatus()
        setDialogTwo(false)
        setError("")
        setDialogThree(true)
        console.log("File uploaded successfully:", data.message);
      }
      else if (status === 400) {
        console.warn("Validation error:", data.message);
        setError(data.message)
      }
      else if (status === 500) {
        console.error("Server error:", data.message);
        setError(data.message)
      }
      else {
        console.log("Unknown error format:", fileRes);
      }
    } catch (error) {
      console.log("Upload request failed:", error);
    }
  }
  

  const handleBack = () => {
    dispatch(setAddBankToTrue())
    setPrimary(false)
  }

  const handleMobileBack = () => {
    dispatch(setOptionSelect("RPD"))
  }

  const handleMobileProceed = async () => {
    if (mobileSelectedOption == "manual") {
      console.log("in if")
      setPrimary(false)
      dispatch(setOptionSelect("Manual"))
      dispatch(setMobileOptionSelected(""))
      return
    } else {
      console.log("in else")
      dispatch(setRpdHitToTrue())
      dispatch(setMobileOptionSelected(mobileSelectedOption))
      dispatch(setLoaderScreenToTrue())
      console.log("in else 11")
    }
    let type
    if (mobileSelectedOption == "PhonePe") {
      type = "phonepe"
    } else if (mobileSelectedOption == "GPay") {
      type = "gpay"
    } else if (mobileSelectedOption == "Paytm") {
      type = "paytm"
    }

    const payload = {
      email: userInfo.CLIENT_ID_MAIL,
      mobile_number: userInfo.MOBILE_NO,
      client_id: userInfo.CLIENT_ID,
      default_account: primary ? "Yes" : "No",
      type
    }

    console.log("mobile rpd Payment", payload)

    try {
      const apiClient = new ApiClient(apiToken);

      const response = await apiClient.fetchData(AppConfig.api.Request.RPD,
        "POST",
        payload
      )
      console.log("Web RPD hit response", response, (response?.status == 200 && response?.data?.Success == "True"))
      if (response?.status == 200 && response?.data?.Success == "True") {
        console.log("Mobile proceed...", response?.data?.id)
        dispatch(setId(response?.data?.id))
        const url = response?.data?.mobileUrl
        console.log("urrrll", url)
        window.location.href = url;
      } else {
        dispatch(setRpdError("Something went wrong please try again"))
      }
    } catch (err) {
      console.error('Bank verification failed:', err);
      dispatch(setRpdError("Something went wrong please try again"))
    }
  }

  const handleModelClose = () => {
    setPrimary(false)
    setMobileSelectedOption("PhonePe")
    dispatch(setRpdMsgModelToFalse())
    dispatch(resetTimeLeft())
  }

  const handleGetBankDetailsForMobile = async (bool) => {
    try{
      console.log("get Details Mobile hit", id)
      const bankAccNos = userBanks?.map(item => item.Bank_AcNo);
      let timedout = bool ? true : false

      const payload = {
        email, mobile_number: mobile, client_id: userId, timedout, id: idRef.current, account_numbers: bankAccNos
      }

      console.log("handleGetBankDetailsForMobile payload", payload)

      const apiClient = new ApiClient(apiToken);
      const response = await apiClient.fetchData(AppConfig.api.Request.VerifyAcc,
        "POST",
        payload
      )

      if (response?.status == 200 && response?.data?.Success == "False" && response?.data?.["Error Description"]?.includes("The request has not completed yet")) {
        console.log("return")

        if (bool) {
          dispatch(setRpdError("The UPI payment is not done yet has not completed yet"))
        }
        return
      }
      else if (response?.status === 200 && response?.data?.Success === "False" && response?.data?.["Error Code"] == "verification" && response?.data?.["Error Description"]?.includes("currently pending")) {
        dispatch(setRpdHitToFalse())
        dispatch(setRpdMsgModelToTrue("The account you are trying to add has already been submitted and is currently pending verification."))
      }
      else if ((response.status === 200 && response.data?.Success === "True" && response?.data?.["Success Description"] == "Bank Added Successfully") || (response.status == 200 && response?.data?.Success == "False" && response?.data?.["Error Description"]?.trim().includes("We have raised this request for further processing")
      )) {
        console.log("hellooo1")
        dispatch(setRpdMsgModelToFalse())
        setError('Bank Account Added Successfully')
        handleClose()
        setSuccessModal(true)
        // dispatch()
      } else if (response.status == 200 && response?.data?.Success == "False" && response?.data["Error Description"]?.includes("already Exist")) {
        console.log("hellooo2")
        dispatch(setRpdMsgModelToFalse())
        setError(`This Bank Account already exists`)
        handleClose()
        setDialog(true)
      }
      else if (response.status == 200 && response?.data.Success == "False" && response?.data["Error Code"] == "Name Miss Match") {
        console.log("hellooo3")
        dispatch(setRpdMsgModelToFalse())
        handleFetchBankStatus()
        handleClose()
        setDialogTwo(true)
      } else {
        console.log("hellooo4")
        let error = response?.data?.["Error Description"] || "Something went wrong.Please try again"
        dispatch(setRpdHitToFalse())
        dispatch(setRpdMsgModelToTrue(error))

      }
    }
    catch(err){
      console.log("Mobile RPD FAiled",err)
      dispatch(setRpdHitToFalse())
      dispatch(setRpdMsgModelToTrue("Something went wrong.Please try again"))
    }
    
  }

  const handleGetBankDetails = async (bool) => {
    const bankAccNos = userBanks?.map(item => item.Bank_AcNo);
    try {
      const payload = {
        email, mobile_number:mobile, client_id: userId, timedout: bool, id: idRef.current, account_numbers: bankAccNos
      }
      console.log("payloaddd✅", payload)
      const apiClient = new ApiClient(apiToken);
      const response = await apiClient.fetchData(AppConfig.api.Request.VerifyAcc,
        "POST",
        payload
      )
      

      if (response?.status == 200 && response?.data?.Success == "False" && response?.data?.["Error Description"].includes("The request has not completed yet")) {
        console.log("return")

        if (bool) {
          dispatch(setRpdError("The UPI payment is not done yet has not completed yet"))
        }
        return
      }
      else if((response.status == 200  && response.data?.Success === "True" && response?.data?.["Success Description"] == "Bank Added Successfully") || (response.status == 200 && response?.data?.Success == "False" && response?.data?.["Error Description"]?.trim()?.includes("We have raised this request for further processing")
      )
      ) {
        console.log("hellooo")
        setError('Bank Account Added Successfully')
        handleClose()
        setSuccessModal(true)
        // dispatch()
      } else if (response.status == 200 && response?.data?.Success == "False" && response?.data?.["Error Description"]?.trim()?.includes("already exists")) {
        setError(`This Bank Account already exists`)
        handleClose()
        setDialog(true)
      }
      else if (response.status == 200 && response?.data.Success == "False" && response?.data["Error Code"] == "Name Miss Match") {
        handleFetchBankStatus()
        handleClose()
        setDialogTwo(true)
      } else {
        dispatch(setWebRpdHitToFalse())
        let error = response?.data?.["Error Description"] || "Somthing went wrong.Please try again"
        setError(error)
        handleClose()
        dispatch(setQrLink(""))
        setErrorModal(true)
      }

    } catch (error) {
      console.error("Bank get details failed:", error);
      setError("Bank get details failed. Something went wrong. please try again")
      handleClose()
      dispatch(setQrLink(""))
      setErrorModal(true)
    }
  }

  const handleHitRpd = async (type) => {
    setShowLodder(true)
    const payload =
     {
      email: userInfo.CLIENT_ID_MAIL,
      mobile_number: userInfo.MOBILE_NO,
      client_id: userInfo.CLIENT_ID,
      default_account: type ? "Yes" : "No",
      type: ""
    }
    console.log("Rpd Payload", payload)
    dispatch(setWebRpdHitToTrue())
    try {
      const apiClient = new ApiClient(apiToken);

      const response = await apiClient.fetchData(AppConfig.api.Request.RPD,
        "POST",
        payload
      )
      console.log("Web RPD hit response", response)

      if (response?.status == 200 && response?.data?.Success == "True") {
        dispatch(setId(response?.data?.id))
        const url = response?.data?.mobileUrl
        setShowLodder(false)
        dispatch(setQrLink(response?.data?.mobileUrl))
        // window.location.href = url;
      } else {
        handleClose()
        dispatch(setQrLink(""))
        setRpdErrorModal(true)
        setShowLodder(false)
      }
    } catch (err) {
      console.error('Bank verification failed:', err);
      setRpdErrorModal(true)
      setShowLodder(false)
    }

  }

  const handleProceedOption = async () => {
    console.log("addBankType", addBankType)

    // if (addBankType == "RPD" && !screen1000px) {
    //    handleHitRpd()
    // }
    dispatch(setOptionSelect(addBankType))
  }
  const handleCheckboxChange = (option) => {
    setAddBankType(option);
  };

  const optionDetails = {
    Manual: [
      "Enter your Bank Account Number",
      "Enter the IFSC Code of your bank",
      "Provide your UPI ID",
    ],
    RPD: [
      "Verify instantly using UPI-based validation",
      "Scan a QR code to authenticate your bank account",
      "A small refundable amount (₹1) may be deducted for verification",
      "Works across major UPI apps like PhonePe, GPay, Paytm"
    ],
  };


  const handleOptionChange = () => {

    dispatch(setMobileOptionSelected(mobileSelectedOption == "manual" ? "" : mobileSelectedOption))
    //  if(mobileSelectedOption == "manual"){
    //    dispatch(setOptionSelect("Manual"))
    //  }
  }


  const PrimaryChoiceStep = ({ onChoice }) => {
    const [selected, setSelected] = useState(null);

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "14px",
          mt: "4px",
          width: "100%",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{ fontSize: "15px", fontWeight: 700, color: "#241E41", lineHeight: 1.3 }}
          >
            Set as primary bank account?
          </Typography>

          <Typography sx={{ fontSize: "12px", color: "#7b6ea0", mt: "4px" }}>
            Your primary account is used for all withdrawals
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: "10px", width: "100%", maxWidth: "320px" }}>

          {/* YES */}
          <Box
            onClick={() => setSelected(true)}
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
              padding: "14px 10px",
              background: selected === false ? "#f5f5f5" : "#fafafa",
              border: selected === true ? "1.5px solid #6c5ce7" : "1.5px solid #e8e4f0",
              borderRadius: "14px",
              cursor: "pointer",
              transition: "all 0.18s ease",
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                background: "#ede9f7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Star size={16} color="#6c5ce7" fill="#6c5ce7" />
            </Box>

            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#241E41" }}>
              Yes, set primary
            </Typography>

            <Typography sx={{ fontSize: "10px", color: "#7b6ea0", textAlign: "center" }}>
              Use for all future withdrawals
            </Typography>
          </Box>

          {/* NO */}
          <Box
            onClick={() => setSelected(false)}
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
              padding: "14px 10px",
              background: selected === false ? "#f5f5f5" : "#fafafa",
              border: selected === false ? "1.5px solid #6c5ce7" : "1.5px solid #e8e4f0",
              borderRadius: "14px",
              cursor: "pointer",
              transition: "all 0.18s ease",
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                background: "#ede9f7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <X size={16} color="#7b6ea0" />
            </Box>

            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#241E41" }}>
              No, skip
            </Typography>

            <Typography sx={{ fontSize: "10px", color: "#7b6ea0", textAlign: "center" }}>
              Keep existing primary account
            </Typography>
          </Box>
        </Box>

        {/* Proceed Button */}
        <Button
          variant="contained"
          disabled={selected === null}
          onClick={() => onChoice(selected)}
          sx={{
            borderRadius: "10px",
            background: "#F3D45E",
            color: "#000000",
            textTransform: "capitalize",
            fontSize: "16px",
            fontWeight: "600",
            width: "200px",
            "&:disabled": { background: "#ddd" },
            "&:hover": {
              background: "#F3D45E",
            },

          }}
        >
          Proceed
        </Button>
      </Box>
    );
  };


  // ─── Step 2: QR code (shown after choice is made) ────────────────────────────

  const QRStep = ({ qrLink, webTimeLeft, primary }) => (
    <Box
      sx={{
        display: "flex", flexDirection: "column",
        alignItems: "center", gap: "10px", mt: "6px", width: "100%",
      }}
    >
      {/* QR Card */}
      <Box
        sx={{
          background: "#ffffff", border: "1.5px solid #e8e4f0",
          borderRadius: "16px", padding: "14px 20px",
          boxShadow: "0 4px 16px rgba(36, 30, 65, 0.07)",
          display: "flex", flexDirection: "column",
          alignItems: "center", gap: "10px", minWidth: "240px",
        }}
      >
        {/* Header: label + optional PRIMARY badge */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography
            sx={{
              fontSize: "10px", fontWeight: 600,
              letterSpacing: "0.1em", textTransform: "uppercase", color: "#7b6ea0",
            }}
          >
            Scan with any UPI app
          </Typography>
          {primary && (
            <Box
              sx={{
                display: "flex", alignItems: "center", gap: "3px",
                background: "#f4f1ff", border: "1px solid #6c5ce7",
                borderRadius: "999px", padding: "2px 8px",
              }}
            >
              <Star size={9} color="#6c5ce7" fill="#6c5ce7" />
              <Typography sx={{ fontSize: "9px", fontWeight: 700, color: "#6c5ce7" }}>
                PRIMARY
              </Typography>
            </Box>
          )}
        </Box>

        {/* QR + Timer side by side */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>

          <Box
            sx={{
              padding: "7px", background: "#fafafa",
              borderRadius: "10px", border: "1px solid #ede9f7",
              lineHeight: 0, flexShrink: 0,
            }}
          >
            <QRCode value={qrLink}  size={130} />
          </Box>

          {/* Timer pill */}
          <Box
            sx={{
              display: "flex", alignItems: "center", gap: "5px",
              background: webTimeLeft <= 10 ? "#fff3f3" : "#f4f1ff",
              border: `1px solid ${webTimeLeft <= 10 ? "#ffcdd2" : "#ddd6f9"}`,
              borderRadius: "999px", padding: "5px 12px", alignSelf: "center",
            }}
          >
            <Clock
              size={12}
              color={webTimeLeft <= 10 ? "#e53935" : "#6c5ce7"}
              strokeWidth={2.5}
            />
            <Typography
              sx={{
                fontWeight: 700, fontSize: "14px",
                fontVariantNumeric: "tabular-nums",
                color: webTimeLeft <= 10 ? "#e53935" : "#241E41",
                letterSpacing: "0.05em",
              }}
            >
              {String(Math.floor(webTimeLeft / 60)).padStart(2, "0")}:
              {String(webTimeLeft % 60).padStart(2, "0")}
            </Typography>
          </Box>
        </Box>
      </Box>     

      {/* Refund note */}
      <Box
        sx={{
          display: "flex", alignItems: "center", gap: "6px",
          background: "#f9f8ff", border: "1px solid #ede9f7",
          borderRadius: "8px", padding: "7px 12px", maxWidth: "300px",
        }}
      >
        <Shield size={12} color="#6c5ce7" style={{ flexShrink: 0 }} />
        <Typography sx={{ fontSize: "11px", color: "#5a5278", lineHeight: 1.5 }}>
          <span style={{ fontWeight: 700, color: "#241E41" }}>₹1</span> debited for
          verification · refunded in{" "}
          <span style={{ fontWeight: 600 }}>3 working days</span>
        </Typography>
      </Box>
    </Box>
  );





  const RpdErrorModal = ({ open, onClose, onTraditional }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: 0,
          maxWidth: "320px",
          width: "90%",
          overflow: "hidden",
          background: "#ffffff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(3px)", background: "rgba(0,0,0,0.3)" },
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", padding: "28px 24px 24px", background: "#fff" }}>

          {/* Close button top-right */}
          <Box
            onClick={onClose}
            sx={{
              position: "absolute", top: 14, right: 14,
              width: 28, height: 28, borderRadius: "50%",
              background: "#f5f5f5", display: "flex",
              alignItems: "center", justifyContent: "center",
              cursor: "pointer", "&:hover": { background: "#eee" },
            }}
          >
            <X size={14} color="#999" />
          </Box>

          {/* Icon */}
          <Box sx={{
            width: 56, height: 56, borderRadius: "50%",
            background: "#fff8e1", border: "1.5px solid #ffe082",
            display: "flex", alignItems: "center", justifyContent: "center", mb: "14px",
          }}>
            <AlertCircle size={26} color="#f59e0b" strokeWidth={2} />
          </Box>

          {/* Title */}
          <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1a1a1a", textAlign: "center", lineHeight: 1.3 }}>
            UPI Verification Failed
          </Typography>

          {/* Subtitle */}
          <Typography sx={{ fontSize: "12px", color: "#666", textAlign: "center", mt: "8px", lineHeight: 1.7 }}>
            We couldn't complete UPI-based verification. You can use{" "}
            <span style={{ fontWeight: 600, color: "#1a1a1a" }}>Traditional Bank Verification</span>{" "}
            instead — it's equally secure.
          </Typography>

          {/* Info box */}
          <Box sx={{
            mt: "16px", width: "100%",
            background: "#f9f9f9", borderRadius: "12px",
            border: "1px solid #efefef", padding: "12px 14px",
          }}>
            <Typography sx={{ fontSize: "11px", color: "#888", lineHeight: 1.7 }}>
              Traditional verification uses your bank account number &amp; IFSC code and typically takes{" "}
              <span style={{ fontWeight: 600, color: "#555" }}>1–2 working days</span>.
            </Typography>
          </Box>

          {/* Divider */}
        

        </Box>
      </DialogContent>
    </Dialog>
  );

  const SimpleErrorModal = ({ open, onClose,msg }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          maxWidth: "280px",
          width: "90%",
          background: "#ffffff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(3px)", background: "rgba(0,0,0,0.3)" },
      }}
    >
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", py: "8px" }}>
          <AlertCircle size={32} color="#f59e0b" strokeWidth={2} />
          <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1a1a1a", textAlign: "center" }}>
            {msg}
          </Typography>
          <Button
            onClick={onClose}
            fullWidth
            sx={{
              mt: "4px", borderRadius: "10px",
              background: "#F3D45E", color: "#1a1a1a",
              fontWeight: 700, fontSize: "13px",
              textTransform: "capitalize", boxShadow: "none",
              "&:hover": { background: "#e8c94a", boxShadow: "none" },
            }}
          >
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );


  const AccountSuccessModal = ({ open, onClose }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          maxWidth: "280px",
          width: "90%",
          background: "#ffffff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(3px)", background: "rgba(0,0,0,0.3)" },
      }}
    >
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", py: "8px" }}>
          <CheckCircle size={36} color="#22c55e" strokeWidth={2} />
          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a1a", textAlign: "center" }}>
            Account Added Successfully!
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "#888", textAlign: "center", lineHeight: 1.6 }}>
            Your bank account will be activated within <span style={{ fontWeight: 600, color: "#1a1a1a" }}>24 hours</span>.
          </Typography>
          <Button
            onClick={onClose}
            fullWidth
            sx={{
              mt: "4px", borderRadius: "10px",
              background: "#F3D45E", color: "#1a1a1a",
              fontWeight: 700, fontSize: "13px",
              textTransform: "capitalize", boxShadow: "none",
              "&:hover": { background: "#e8c94a", boxShadow: "none" },
            }}
          >
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );


  return (
    <Container sx={{ background: "#180D2B", width: "100%", overflowX: "auto" }}>

      {
        (loaderScreen && isTabNMobile) ?
          <Grid sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: "80px" }}>

            <img src={paymentIcons[mobileOptionSelected]} alt={mobileOptionSelected} className={styles.img3} />
            <Typography className={styles.loadTxt}>
              We're verifying your bank account via {mobileOptionSelected}
            </Typography>

            <Typography className={styles.loadTxt1}>
              Open your {mobileOptionSelected} app and complete the transaction
            </Typography>

            <Typography className={styles.loadTxt2}>
              Approve within
            </Typography>

            <Typography
              sx={{
                marginTop: "15px",
                fontWeight: 500,
                fontSize: "18px",
                textAlign: "center",
                // "@media (max-width:600px)": {
                //   fontSize: "16px",
                // },
                // "@media (max-width:480px)": {
                //   fontSize: "14px",
                // },
                // "@media (max-width:360px)": {
                //   fontSize: "12px",
                // },
              }}
            >
              {String(Math.floor(timeLeft / 60)).padStart(2, "0")}:
              {String(timeLeft % 60).padStart(2, "0")}
            </Typography>


            <Typography className={styles.loadTxt3}>
              Do not press back button or close the tab
            </Typography>
          </Grid> :

          <>

            {isSmallScreen && (
              <Grid sx={{ minHeight: "100vh", width: "100%" }}>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography
                    sx={{
                      margin: "0px 0px 0px 20px",
                      padding: "20px 0px 0px 0px",
                      fontSize: "25px",
                      "@media screen and (max-width : 420px)": {
                        fontSize: "22px"
                      }
                    }}
                  >
                    {selectedOption && selectedOption}
                  </Typography>
                  <Button
                    onTouchStart={handleAddBankAccount}
                    sx={{ margin: "20px 15px 0px 0px", height: '35px' }}
                  >
                    Add Account
                  </Button>
                </Grid>

                <Grid sx={{ margin: "0px 20px 0px 10px" }}>
                  {selectedOption == "Bank Account" && (
                    <List>
                      {Array.isArray(userBanks) &&
                        userBanks.sort(
                          (a, b) =>
                            (b.Default_Ac === "Yes") - (a.Default_Ac === "Yes")
                        ).map((item, i) => {
                          return (
                            <ListItem
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                                background: "#1F1741",
                                borderRadius: "10px",
                                margin: "10px 5px 0px 5px",
                              }}
                            >
                              <ListItemText
                                sx={{ width: "100%" }}
                                primary={
                                  <Grid
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="end"
                                  >
                                    <Typography>{item?.Default_Ac === "Yes" ? "Primary Account" : "Account"}</Typography>
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      sx={{
                                        borderColor: '#F3D45E',
                                        color: "#F3D45E",
                                        background: "none",
                                        padding: '2px 6px',
                                        fontSize: "13px",
                                        '&:hover': {
                                          borderColor: '#F3D45E',
                                          backgroundColor: 'rgba(243, 212, 94, 0.1)',
                                        }
                                      }}
                                      onTouchStart={() => handleEditBankAcc(i, item?.UPIBANKID)}
                                    >
                                      {item?.UPIBANKID ? 'Edit Upi Id' : 'Add Upi Id'}
                                    </Button>
                                  </Grid>
                                }
                                secondary={item.Bank_Name}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                              <ListItemText
                                sx={{ width: "100%" }}
                                primary={<Grid
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="end"
                                >
                                  <Typography>Account Number</Typography>
                                  <Typography>Status</Typography>
                                </Grid>}
                                secondary={<Grid
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="end"
                                >
                                  <Typography>{item.Bank_AcNo}</Typography>
                                  <Typography sx={{ color: "#00FF59 !important", fontSize: "13px" }}>Active</Typography>
                                </Grid>}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                              {/* Added bank upi - 07-08-24 - Dev Srini */}
                              <ListItemText
                                primary={"Bank Upi Id"}
                                secondary={item.UPIBANKID ? item.UPIBANKID : "-"}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                              <ListItemText
                                primary={"Branch"}
                                secondary={item.Bank_Address}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                            </ListItem>
                          );
                        })}


                      {/* {Array.isArray(bankVerStats2) && (bankVerStats2[0]?.status?.includes("NAME_MISMATCH") || bankVerStats2[0]?.status?.includes("REJECTED")) &&
                  bankVerStats2.map((item, i) => {
                    return (
                      <ListItem
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          background: "#241E41",
                          borderRadius: "10px",
                          margin: "10px 5px 0px 5px",
                        }}
                      >
                        <ListItemText
                          sx={{ width: "100%" }}
                          primary={
                            <Grid
                              display="flex"
                              justifyContent="space-between"
                              alignItems="end"
                            >
                              <Typography>Bank</Typography>
                              {!bankVerStats2[0]?.file_status?.includes('DOCUMENT_UPLOADED') ? (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      borderColor: '#F3D45E',
                                      color: "#F3D45E",
                                      background: "none",
                                      padding: '2px 10px',
                                      '&:hover': {
                                        borderColor: '#F3D45E',
                                        backgroundColor: 'rgba(243, 212, 94, 0.1)',
                                      }
                                    }}
                                    onTouchStart={handleFileUpload}
                                  >
                                    Fix Issue
                                  </Button>
                                ) : bankVerStats2[0]?.status?.includes('REJECTED') ? (
                                  <Tooltip
                                    enterTouchDelay={0} 
                                    leaveTouchDelay={9000} 
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: '#fff',
                                          color: '#9A9A9A',
                                          maxWidth: 300,
                                            fontSize: 14,
                                            border: '1px solid #fff',
                                            p: 2.0,
                                            whiteSpace: 'pre-line'
                                          },
                                        },
                                      }}
                                      title={
                                        <Box sx={{ lineHeight: 1.5 }}>
                                          Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification failed due to the following reason:
                                          <br />
                                          <span style={{ color: '#000' }}>{bankVerStats2[0]?.verified_comments}</span>
                                          <br />
                                          For further assistance, kindly contact our Support team at: <b>Support@tradeboss.co</b>
                                        </Box>
                                      }
                                    >
                                      <InfoOutlinedIcon
                                        sx={{
                                          color: '#F3D45E',
                                          fontSize: 22,
                                          cursor: 'pointer',
                                          '&:hover': {
                                            color: '#c9a600',
                                          },
                                        }}
                                      />
                                    </Tooltip>
                                  
                                ) : (
                                <>
                                </>
                              )}
                            </Grid>
                          }
                          secondary={item?.bank_name}
                          primaryTypographyProps={{ color: "#999999" }}
                          secondaryTypographyProps={{ color: "#FFFFFF" }}
                        />
                        <ListItemText
                          sx={{ width: "100%" }}
                          primary={<Grid
                            display="flex"
                            justifyContent="space-between"
                            alignItems="end"
                          >
                            <Typography>Account Number</Typography>
                            <Typography>Status</Typography>
                          </Grid>}
                          secondary={<Grid
                            display="flex"
                            justifyContent="space-between"
                            alignItems="end"
                          >
                            <Typography>{item.account_no}</Typography>
                            {bankVerStats2[0]?.status?.includes('REJECTED') ? (

                              <Typography
                                sx={{ color: "#F74542 !important", fontSize: "13px" }}
                              >
                                Failed
                              </Typography>
                            ) : (
                              <Typography
                                sx={{ color: "#EE9906 !important", fontSize: "13px" }}
                              >
                                In-Progress
                              </Typography>
                            )}
                          </Grid>}
                          primaryTypographyProps={{ color: "#999999" }}
                          secondaryTypographyProps={{ color: "#FFFFFF" }}
                        />
                        
                        <ListItemText
                          primary={"Bank Upi Id"}
                          secondary={item.upi_id ? item.upi_id : "-"}
                          primaryTypographyProps={{ color: "#999999" }}
                          secondaryTypographyProps={{ color: "#FFFFFF" }}
                        />
                        <ListItemText
                          primary={"Branch"}
                          secondary={item?.bank_branch}
                          primaryTypographyProps={{ color: "#999999" }}
                          secondaryTypographyProps={{ color: "#FFFFFF" }}
                        />
                      </ListItem>
                    );
                  })} */}

                      {Array.isArray(bankVerStats2) && (bankVerStats2[0]?.status?.includes("NAME_MISMATCH") || bankVerStats2[0]?.status?.includes("REJECTED") || bankVerStats2[0]?.status?.includes("TECHXL_ERROR") || bankVerStats2[0]?.status?.includes("AUTOMATIC") || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE")) &&
                        bankVerStats2.map((item, i) => {
                          return (
                            <ListItem
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                                background: "#241E41",
                                borderRadius: "10px",
                                margin: "10px 5px 0px 5px",
                              }}
                            >
                              <ListItemText
                                sx={{ width: "100%" }}
                                primary={
                                  <Grid
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="end"
                                  >
                                    {/* {console.log("resulltttt", bankVerStats2[0]?.status?.includes('REJECTED'), (bankVerStats2[0]?.status?.includes('TECHXL_ERROR') || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE")), !bankVerStats2[0]?.file_status?.includes('DOCUMENT_UPLOADED'))}
                                    <Typography>Bank</Typography>
                                    {bankVerStats2[0]?.file_status?.includes('REJECTED') ? (
                                      <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={9000}
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: '#fff',
                                              color: '#9A9A9A',
                                              maxWidth: 300,
                                              fontSize: 14,
                                              border: '1px solid #fff',
                                              p: 2.0,
                                              whiteSpace: 'pre-line'
                                            },
                                          },
                                        }}
                                        title={
                                          <Box sx={{ lineHeight: 1.5 }}>
                                            Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification failed due to the following reason:
                                            <br />
                                            <span style={{ color: '#000' }}>{bankVerStats2[0]?.verified_comments}</span>
                                            <br />
                                            For further assistance, kindly contact our Support team at: <b>Support@tradeboss.co</b>
                                          </Box>
                                        }
                                      >
                                        <InfoOutlinedIcon
                                          sx={{
                                            color: '#F3D45E',
                                            fontSize: 22,
                                            cursor: 'pointer',
                                            '&:hover': {
                                              color: '#c9a600',
                                            },
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (bankVerStats2[0]?.status?.includes('TECHXL_ERROR') || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE")) ? (
                                        <Tooltip
                                          enterTouchDelay={0}
                                          leaveTouchDelay={9000}
                                          componentsProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: '#fff',
                                                color: '#9A9A9A',
                                                maxWidth: 300,
                                                fontSize: 14,
                                                border: '1px solid #fff',
                                                p: 2.0,
                                                whiteSpace: 'pre-line'
                                              },
                                            },
                                          }}
                                          title={
                                            <Box sx={{ lineHeight: 1.5 }}>
                                              Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification failed due to the following reason:
                                              <br />
                                              <span style={{ color: '#000' }}>{bankVerStats2[0]?.verified_comments}</span>
                                              <br />
                                              For further assistance, kindly contact our Support team at: <b>Support@tradeboss.co</b>
                                            </Box>
                                          }
                                        >
                                          <InfoOutlinedIcon
                                            sx={{
                                              color: '#F3D45E',
                                              fontSize: 22,
                                              cursor: 'pointer',
                                              '&:hover': {
                                                color: '#c9a600',
                                              },
                                            }}
                                          />
                                        </Tooltip>

                                      ) : !bankVerStats2[0]?.file_status?.includes('DOCUMENT_UPLOADED') ? (
                                      <>
                                            <Button
                                              variant="outlined"
                                              size="small"
                                              sx={{
                                                borderColor: '#F3D45E',
                                                color: "#F3D45E",
                                                background: "none",
                                                padding: '2px 10px',
                                                '&:hover': {
                                                  borderColor: '#F3D45E',
                                                  backgroundColor: 'rgba(243, 212, 94, 0.1)',
                                                }
                                              }}
                                              onTouchStart={handleFileUpload}
                                            >
                                              Fix Issue
                                            </Button>
                                      </>
                                    )
                                  :(
                                    <>

                                    </>
                                  )} */}



                                    <Typography>Account</Typography>

                                    {bankVerStats2[0]?.status?.includes('REJECTED') ? (
                                      <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={9000}
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: '#fff',
                                              color: '#9A9A9A',
                                              maxWidth: 300,
                                              fontSize: 14,
                                              border: '1px solid #fff',
                                              p: 2.0,
                                              whiteSpace: 'pre-line'
                                            },
                                          },
                                        }}
                                        title={
                                          <Box sx={{ lineHeight: 1.5 }}>
                                            Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification failed due to the following reason:
                                            <br />
                                            <span style={{ color: '#000' }}>{bankVerStats2[0]?.verified_comments}</span>
                                            <br />
                                            For further assistance, kindly contact our Support team at: <b>Support@tradeboss.co</b>
                                          </Box>
                                        }
                                      >
                                        <InfoOutlinedIcon
                                          sx={{
                                            color: '#F3D45E',
                                            fontSize: 22,
                                            cursor: 'pointer',
                                            '&:hover': {
                                              color: '#c9a600',
                                            },
                                          }}
                                        />
                                      </Tooltip>

                                    ) : (bankVerStats2[0]?.status?.includes('TECHXL_ERROR') || bankVerStats2[0]?.status?.includes("AUTOMATIC") ||
                                      bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE")) ? (

                                      <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={9000}
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: '#fff',
                                              color: '#9A9A9A',
                                              maxWidth: 300,
                                              fontSize: 14,
                                              border: '1px solid #fff',
                                              p: 2.0,
                                              whiteSpace: 'pre-line'
                                            },
                                          },
                                        }}
                                        title={
                                          <Box sx={{ lineHeight: 1.5 }}>
                                            Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification is in progress will updated with in 24 Hrs.For assistance contact:
                                            <b>Support@tradeboss.co</b>
                                          </Box>
                                        }
                                      >
                                        <InfoOutlinedIcon
                                          sx={{
                                            color: '#F3D45E',
                                            fontSize: 22,
                                            cursor: 'pointer',
                                            '&:hover': {
                                              color: '#c9a600',
                                            },
                                          }}
                                        />
                                      </Tooltip>

                                    ) : !bankVerStats2[0]?.file_status?.includes('DOCUMENT_UPLOADED') ? (

                                      <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                          borderColor: '#F3D45E',
                                          color: "#F3D45E",
                                          background: "none",
                                          padding: '2px 10px',
                                          '&:hover': {
                                            borderColor: '#F3D45E',
                                            backgroundColor: 'rgba(243, 212, 94, 0.1)',
                                          }
                                        }}
                                        onTouchStart={handleFileUpload}
                                      >
                                        Fix Issue
                                      </Button>

                                    ) : (
                                      <></>
                                    )}

                                  </Grid>
                                }
                                secondary={item?.bank_name}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                              <ListItemText
                                sx={{ width: "100%" }}
                                primary={<Grid
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="end"
                                >
                                  <Typography>Account Number</Typography>
                                  <Typography>Status</Typography>
                                </Grid>}
                                secondary={<Grid
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="end"
                                >
                                  <Typography>{item.account_no}</Typography>
                                  {bankVerStats2[0]?.status?.includes('REJECTED') ? (

                                    <Typography
                                      sx={{ color: "#F74542 !important", fontSize: "13px" }}
                                    >
                                      Failed
                                    </Typography>
                                  ) : (
                                    <Typography
                                      sx={{ color: "#EE9906 !important", fontSize: "13px" }}
                                    >
                                      In-Progress
                                    </Typography>
                                  )}
                                </Grid>}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />

                              <ListItemText
                                primary={"Bank Upi Id"}
                                secondary={item.upi_id ? item.upi_id : "-"}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                              <ListItemText
                                primary={"Branch"}
                                secondary={item?.bank_branch}
                                primaryTypographyProps={{ color: "#999999" }}
                                secondaryTypographyProps={{ color: "#FFFFFF" }}
                              />
                            </ListItem>
                          );
                        })}

                      {/* <Grid display="flex" justifyContent="end">
                </Grid> */}
                    </List>
                  )}
                </Grid>
              </Grid>
            )}
            {!isSmallScreen && (
              <>
                <Grid
                  sx={{
                    display: "flex",
                    background: "#1F1741",
                    marginTop: "20px",
                    borderRadius: "10px",
                  }}
                ></Grid>
                <Grid sx={{ background: "#1F1741", minHeight: "100vh" }}>
                  {selectedOption == "" && (
                    <Grid sx={{ display: "flex", justifyContent: "center" }}>
                      <img src={image} style={{ marginTop: "125px" }} height={120} />
                    </Grid>
                  )}
                  <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography
                      sx={{
                        margin: "0px 0px 0px 20px",
                        padding: "20px 0px 0px 0px",
                        fontSize: "25px",
                        "@media screen and (max-width : 420px)": {
                          fontSize: "22px"
                        }
                      }}
                    >
                      {selectedOption && selectedOption}
                    </Typography>
                    <Button
                      onClick={handleAddBankAccount}
                      sx={{ margin: "20px 15px 0px 0px", height: '35px' }}
                    >
                      Add Account
                    </Button>
                  </Grid>
                  {selectedOption == "Bank Account" && (
                    <Grid sx={{ margin: "0px 20px 0px 10px" }}>
                      <List>
                        {Array.isArray(userBanks) &&
                          userBanks
                            .sort(
                              (a, b) =>
                                (b.Default_Ac === "Yes") - (a.Default_Ac === "Yes")
                            ).map((item, i) => {
                              return (
                                <ListItem
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    background: "#241E41",
                                    borderRadius: "10px",
                                    margin: "10px 5px 0px 5px",
                                  }}
                                >
                                  <ListItemText
                                    sx={{ width: "100%" }}
                                    primary={
                                      <Box display="flex">
                                        <Grid width="30%">
                                          <Typography
                                            className={styles.listPrimaryText}
                                          >
                                            {item?.Default_Ac == "Yes" ? 'Primary Account' : 'Account'}
                                          </Typography>
                                        </Grid>
                                        <Grid width="30%">
                                          <Typography
                                            className={styles.listPrimaryText}
                                            marginLeft="10px"
                                          >
                                            Bank
                                          </Typography>
                                        </Grid>
                                        <Grid width="30%">
                                          <Typography
                                            className={styles.listPrimaryText}
                                            marginLeft="10px"
                                          >
                                            Branch
                                          </Typography>
                                        </Grid>
                                        <Grid width="30%">
                                          {/* Added bank upi - 07-08-24 - Dev Srini */}
                                          <Typography
                                            className={styles.listPrimaryText}
                                            marginLeft="10px"
                                          >
                                            Bank Upi Id
                                          </Typography>
                                        </Grid>
                                        <Grid width="25%">
                                          <Typography
                                            className={styles.listPrimaryText}
                                            marginLeft="10px"
                                          >
                                            Status
                                          </Typography>
                                        </Grid>
                                        {/* Removed edit icon added text - 07-08-24 - Dev Srini */}
                                        <Grid
                                          width="15%"

                                        >
                                          <Button
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                              borderColor: '#F3D45E',
                                              color: "#F3D45E",
                                              background: "none",
                                              padding: '2px 10px',
                                              fontSize: "13px",
                                              '&:hover': {
                                                borderColor: '#F3D45E',
                                                backgroundColor: 'rgba(243, 212, 94, 0.1)',
                                              }
                                            }}
                                            onClick={() => handleEditBankAcc(i, item?.UPIBANKID)}
                                          >
                                            {item?.UPIBANKID ? 'Edit Upi Id' : 'Add Upi Id'}
                                          </Button>
                                        </Grid>
                                      </Box>
                                    }
                                    secondary={
                                      <Box display="flex">
                                        <Grid width="30%">
                                          <Typography
                                            className={styles.listSecondaryText}
                                          >
                                            {item.Bank_AcNo}
                                          </Typography>
                                        </Grid>
                                        <Grid width="30%">
                                          <Typography
                                            marginLeft="10px"
                                            className={styles.listSecondaryText}
                                          >
                                            {item.Bank_Name}
                                          </Typography>
                                        </Grid>
                                        <Grid width="30%">
                                          <Typography
                                            marginLeft="10px"
                                            className={styles.listSecondaryText}
                                          >
                                            {item.Bank_Address}
                                          </Typography>
                                        </Grid>
                                        {/* Added bank upi id - 07-08-24 - Dev Srini */}
                                        <Grid width="30%">
                                          <Typography
                                            marginLeft="10px"
                                            className={styles.listSecondaryText}
                                          >
                                            {item.UPIBANKID ? item.UPIBANKID : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid width="25%">
                                          <Typography
                                            marginLeft="10px"
                                            className={styles.listSecondaryText}
                                            sx={{ color: "#00FF59 !important" }}
                                          >
                                            Active
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          width="15%"
                                          display="flex"
                                          justifyContent="center"
                                        >

                                        </Grid>
                                      </Box>
                                    }
                                  />
                                </ListItem>
                              );
                            })}


                        {Array.isArray(bankVerStats2) && (bankVerStats2[0]?.status?.includes("NAME_MISMATCH") || bankVerStats2[0]?.status?.includes("REJECTED") || bankVerStats2[0]?.status?.includes("TECHXL_ERROR") || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE") || bankVerStats2[0]?.status?.includes("AUTOMATIC")) && <Divider sx={{ borderColor: "#000000", marginY: 1, }} />}

                        {Array.isArray(bankVerStats2) && (bankVerStats2[0]?.status?.includes("NAME_MISMATCH") || bankVerStats2[0]?.status?.includes("REJECTED") || bankVerStats2[0]?.status?.includes("TECHXL_ERROR") || bankVerStats2[0]?.status?.includes("AUTOMATIC") || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE") || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE")) &&
                          bankVerStats2.map((item, i) => {
                            return (
                              <ListItem
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "start",
                                  background: "#241E41",
                                  borderRadius: "10px",
                                  margin: "10px 5px 0px 5px",
                                }}
                              >
                                <ListItemText
                                  sx={{ width: "100%" }}
                                  primary={
                                    <Box display="flex">
                                      <Grid width="30%">
                                        <Typography
                                          className={styles.listPrimaryText}
                                        >
                                          Account
                                        </Typography>
                                      </Grid>
                                      <Grid width="30%">
                                        <Typography
                                          className={styles.listPrimaryText}
                                          marginLeft="10px"
                                        >
                                          Bank
                                        </Typography>
                                      </Grid>
                                      <Grid width="30%">
                                        <Typography
                                          className={styles.listPrimaryText}
                                          marginLeft="10px"
                                        >
                                          Branch
                                        </Typography>
                                      </Grid>
                                      <Grid width="30%">

                                        <Typography
                                          className={styles.listPrimaryText}
                                          marginLeft="10px"
                                        >
                                          Bank Upi Id
                                        </Typography>
                                      </Grid>
                                      <Grid width="25%">
                                        <Typography
                                          className={styles.listPrimaryText}
                                          marginLeft="10px"
                                        >
                                          Status
                                        </Typography>
                                      </Grid>
                                      {bankVerStats2[0]?.status?.includes('REJECTED') ? (
                                        // CASE 2 → TOOLTIP
                                        <Grid width="15%">
                                          <Tooltip
                                            placement="left"
                                            enterTouchDelay={0}
                                            leaveTouchDelay={9000}
                                            componentsProps={{
                                              tooltip: {
                                                sx: {
                                                  backgroundColor: '#fff',
                                                  color: '#9A9A9A',
                                                  maxWidth: 700,
                                                  fontSize: 14,
                                                  border: '1px solid #fff',
                                                  p: 2.5,
                                                  whiteSpace: 'pre-line'
                                                },
                                              },
                                            }}
                                            title={
                                              <box>
                                                Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification failed due to:
                                                <br />
                                                <span style={{ color: '#000' }}>{bankVerStats2[0]?.verified_comments}</span>
                                                <br />
                                                For assistance contact: <b>Support@tradeboss.co</b>
                                              </box>
                                            }
                                          >
                                            <InfoOutlinedIcon
                                              sx={{
                                                color: '#F3D45E',
                                                fontSize: 24,
                                                cursor: 'pointer',
                                                '&:hover': { color: '#c9a600' },
                                              }}
                                            />
                                          </Tooltip>
                                        </Grid>

                                      ) : (bankVerStats2[0]?.status?.includes('TECHXL_ERROR') || bankVerStats2[0]?.status?.includes("NON_INDIVIDUAL_BANK_ACCOUNT_TYPE") || bankVerStats2[0]?.status?.includes('AUTOMATIC') ) ? (
                                        // CASE 3 → EMPTY (Nothing displayed)
                                        <Grid width="15%">
                                          <Tooltip
                                            placement="left"
                                            enterTouchDelay={0}
                                            leaveTouchDelay={9000}
                                            componentsProps={{
                                              tooltip: {
                                                sx: {
                                                  backgroundColor: '#fff',
                                                  color: '#9A9A9A',
                                                  maxWidth: 700,
                                                  fontSize: 14,
                                                  border: '1px solid #fff',
                                                  p: 2.5,
                                                  whiteSpace: 'pre-line'
                                                },
                                              },
                                            }}
                                            title={
                                              <box>
                                                Bank account <b style={{ letterSpacing: 1 }}>{bankVerStats2[0]?.account_no}</b> verification is in progress will updated with in 24 Hrs.For assistance contact: <b>Support@tradeboss.co</b>
                                                {/* <br />
                                                  <span style={{ color: '#000' }}>{bankVerStats2[0]?.verified_comments}</span>
                                                  <br /> */}

                                              </box>
                                            }
                                          >
                                            <InfoOutlinedIcon
                                              sx={{
                                                color: '#F3D45E',
                                                fontSize: 24,
                                                cursor: 'pointer',
                                                '&:hover': { color: '#c9a600' },
                                              }}
                                            />
                                          </Tooltip>
                                        </Grid>
                                      ) : !bankVerStats2[0]?.file_status?.includes('DOCUMENT_UPLOADED') ? (
                                        // CASE 1 → FIX ISSUE
                                        <Grid width="15%">
                                          <Button
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                              borderColor: '#F3D45E',
                                              color: "#F3D45E",
                                              background: "none",
                                              padding: '2px 10px',
                                              '&:hover': {
                                                borderColor: '#F3D45E',
                                                backgroundColor: 'rgba(243, 212, 94, 0.1)',
                                              }
                                            }}
                                            onClick={handleFileUpload}
                                          >
                                            Fix Issue
                                          </Button>
                                        </Grid>

                                      ) : (
                                        // DEFAULT → EMPTY
                                        <Grid width="15%"></Grid>
                                      )}

                                    </Box>
                                  }
                                  secondary={
                                    <Box display="flex">
                                      <Grid width="30%">
                                        <Typography
                                          className={styles.listSecondaryText}
                                        >
                                          {item.account_no}
                                        </Typography>
                                      </Grid>
                                      <Grid width="30%">
                                        <Typography
                                          marginLeft="10px"
                                          className={styles.listSecondaryText}
                                        >
                                          {item.bank_name}
                                        </Typography>
                                      </Grid>
                                      <Grid width="30%">
                                        <Typography
                                          marginLeft="10px"
                                          className={styles.listSecondaryText}
                                        >
                                          {item.bank_branch}
                                        </Typography>
                                      </Grid>

                                      <Grid width="30%">
                                        <Typography
                                          marginLeft="10px"
                                          className={styles.listSecondaryText}
                                        >
                                          {item.upi_id ? item.upi_id : "-"}
                                        </Typography>
                                      </Grid>
                                      {bankVerStats2[0]?.status?.includes('REJECTED') ? (
                                        <Grid width="25%">
                                          <Typography
                                            marginLeft="10px"
                                            className={styles.listSecondaryText}
                                            sx={{ color: "#F74542 !important" }}
                                          >
                                            Failed
                                          </Typography>
                                        </Grid>) : (
                                        <Grid width="25%">
                                          <Typography
                                            marginLeft="10px"
                                            className={styles.listSecondaryText}
                                            sx={{ color: "#EE9906 !important" }}
                                          >
                                            In-Progress
                                          </Typography>
                                        </Grid>
                                      )}
                                      <Grid
                                        width="15%"
                                      >

                                      </Grid>
                                    </Box>
                                  }
                                />
                              </ListItem>
                            );
                          })}
                      </List>
                    </Grid>
                  )}
                </Grid>
              </>
            )}
            {isEditBankAcc ? (
              <Modal open={modal} sx={{ border: "none" }}>
                <Box
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: isSmallScreen ? "90%" : "75%",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    // height: 'auto',
                    outline: "none",
                    background: "#FFFFFF",
                    p: 4,
                    borderRadius: "8px",
                    padding: "2%",
                    paddingTop: "0%",
                    paddingRight: "0%",
                    justifyContent: "center",
                    alignItems: "center",
                    "@media only screen and (max-device-width: 480px)": {
                      width: "90%",
                    },
                  }}
                >
                  <Grid sx={{ display: "flex", justifyContent: "end" }}>
                    <IconButton onClick={() => {
                      setPrimary(false)
                      setBankUpi('')
                      handleClose()
                    }}>
                      <CloseIcon sx={{ color: "black" }} />
                    </IconButton>
                  </Grid>
                  <Typography
                    sx={{ color: "black", fontSize: "20px", fontWeight: "bold", marginBottom: "15px" }}
                  >
                    Edit Bank Account
                  </Typography>

                  <TxtField
                    sx={{ width: isSmallScreen ? "320px" : "350px", background: "#E8E8E8" }}
                    type="number"
                    value={userBanks[editBankAccIndex].Bank_AcNo}
                    label="Bank Account Number*" // dev Srini - (12-03-25)
                    variant="outlined"
                    InputLabelProps={{
                      style: { color: "#000000" },
                    }}
                  />
                  <br />
                  <TxtField
                    sx={{ width: isSmallScreen ? "320px" : "350px", background: "#E8E8E8" }}
                    value={userBanks[editBankAccIndex].IFSC_CODE_ACT}
                    label="IFSC Code*"
                    variant="outlined"
                    InputLabelProps={{
                      style: { color: "#000000" },
                    }}
                  />
                  <br />
                  <TxtField
                    sx={{ width: isSmallScreen ? "320px" : "350px" }}
                    value={bankUpi}
                    onChange={(e) => setBankUpi(e.target.value)}
                    error={bankUpiError}
                    helperText={bankUpiError && bankUpiValidationMsg}
                    label="Enter Bank Upi"
                    variant="outlined"
                    InputLabelProps={{
                      style: { color: "#000000" },
                    }}
                  />
                  <FormGroup>
                    {userBanks[editBankAccIndex].Default_Ac == "No" && <FormControlLabel
                      sx={{
                        color: "black",
                        fontSize: "12px !important",
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                        },
                      }}
                      control={
                        <Checkbox
                          checked={primary}
                          onChange={() => setPrimary(!primary)}
                          sx={{
                            "& .MuiSvgIcon-fontSizeMedium": {
                              color: "black",
                            },
                          }}
                        />
                      }
                      label="Set as primary"
                    />}
                    <FormControlLabel
                      sx={{
                        color: "black",
                        alignItems: "flex-start",
                        marginTop: userBanks[editBankAccIndex].Default_Ac == "Yes" && "10px !important",
                        "& .MuiFormControlLabel-label": {
                          // marginTop: '15px',
                          fontSize: "14px",
                          paddingRight: "1.5%",
                        },
                      }}
                      control={
                        <Checkbox
                          checked
                          sx={{
                            "& .MuiSvgIcon-fontSizeMedium": {
                              color: "black",
                              marginTop: '5px',
                            },
                            alignItems: "flex-start",
                            paddingTop: "0px"
                          }}
                        />
                      }
                      label="I/We hereby declare that the above information provided by me, is true and to the best of my knowledge. I/We undertake to inform Triveni Management Consultancy Services Ltd. of any discrepancies, changes, or incorrect information that I become aware of, immediately. I/We understand that in case any information provided above is incorrect or misleading, I/We would be held liable for all such consequences/actions taken with respect to the above information. This change will affect the Trading and Demat account that I hold with Triveni Management Consultancy Services Ltd."
                    />
                  </FormGroup>

                  <Button sx={{ marginTop: "20px" }} onClick={(e) => handleEditFormSubmit(e)}>
                    <b>Submit</b>
                  </Button>
                  {/* </Box> */}
                </Box>
              </Modal>
            ) : (
              <Modal open={openModel} sx={{ border: "none" }}>
                <Box
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: isSmallScreen ? "90%" : "75%",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    // height: 'auto',
                    outline: "none",
                    background: "#FFFFFF",
                    p: 4,
                    borderRadius: "8px",
                    padding: "2%",
                    paddingTop: "0%",
                    paddingRight: "0%",
                    justifyContent: "center",
                    alignItems: "center",
                    "@media only screen and (max-device-width: 480px)": {
                      width: "90%",
                    },
                  }}
                >

                  <Grid sx={{ display: "flex", justifyContent: "end" }}>
                    <IconButton onClick={handleClose}>
                      <CloseIcon sx={{ color: "black" }} />
                    </IconButton>
                  </Grid>
                  {/* <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <IconButton onClick={handleClose}>
                <CloseIcon sx={{ color: "black" }} />
              </IconButton>
            </Grid>
            <Typography
              sx={{ color: "black", fontSize: "20px", fontWeight: "bold" }}
            >
              Add Bank Account
            </Typography> */}

                  {
                    (isTabNMobile && optionSelected == "Manual") ?
                      <Grid sx={{ display: "flex", flexDirection: "row", gap: "10px" }}>

                        <img src={backBtn} className={styles.img1} onClick={handleMobileBack} />
                        < Typography
                          sx={{ color: "black", fontSize: "20px", fontWeight: "bold" }}
                        >
                          Add Bank Account
                        </Typography>
                      </Grid>

                      :
                      < Typography
                        sx={{ color: "black", fontSize: "20px", fontWeight: "bold" }}
                      >
                        Add Bank Account
                      </Typography>
                  }
                  <List
                    sx={{ listStyleType: "disc", marginLeft: "20px", fontSize: "15px" }}
                  >
                    <ListItem className={styles.listItem}>
                      Please map your own bank account to your trading account. You
                      cannot link a third party bank account to your trading account.
                    </ListItem>
                    <ListItem className={styles.listItem}>
                      If modifying primary bank account, post successful verification,
                      your existing primary bank will be unmapped.
                    </ListItem>
                    <ListItem className={styles.listItem}>
                      Charge of ₹25 + 18% GST will be levied for account modification.
                    </ListItem>
                  </List>
                  {/* <Box component="form" onSubmit={(e)=>handleFormSubmit(e)} autoComplete='off' > */}
                  {/* Eye icon added, srini (07-04-25) */}
                  {
                    !isTabNMobile && <Grid sx={{ display: "flex", gap: "10px" }}>
                      {
                        !addBank && <img src={backBtn} className={styles.img} onClick={handleBack} />
                      }
                      {
                        optionSelected == "" && <Typography className={styles.heading1}>Select the Way to add bank account</Typography>
                      }

                      {
                        optionSelected == "Manual" && <Typography className={styles.heading}>Add Bank Details Manually</Typography>
                      }

                      {
                        optionSelected == "RPD" && <Typography className={styles.heading}>Verify Bank Account instantly via UPI</Typography>
                      }

                    </Grid>
                  }



                  {
                    (addBank && !isTabNMobile) &&
                    <Grid sx={{ paddingRight: "30px" }}>
                      {[
                        { name: "RPD", label: "Verify Bank Account instantly via UPI" },
                        { name: "Manual", label: "Add Bank Details Manually" },
                      ].map((item) => (
                        <Box
                          key={item.name}
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "#fff !important",      // White background
                            border: "1px solid #000",                // Black border
                            borderRadius: 2,
                            cursor: "pointer",
                            color: "#000",                            // Black text
                          }}
                          onClick={() => handleCheckboxChange(item.name)}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={addBankType === item.name}
                                onChange={() => handleCheckboxChange(item.name)}
                                sx={{ color: "#000" }}               // Checkbox color
                              />
                            }
                            label={item.label}
                            sx={{ color: "#000" }}                    // Label black
                          />

                          {addBankType === item.name && (
                            <Box sx={{ pl: 4, mt: 1 }}>
                              <Box
                                component="ul"
                                sx={{
                                  pl: 3,
                                  mt: 1,
                                  listStyleType: "disc",
                                  margin: 0,
                                  color: "#000",                      // Black text

                                  "@media (max-width: 700px)": {
                                    pl: 2,
                                    fontSize: "14px",
                                  },

                                  "@media (max-width: 480px)": {
                                    pl: 1,
                                    fontSize: "13px",
                                  },
                                }}
                              >
                                {optionDetails[item.name].map((point, index) => (
                                  <Box
                                    component="li"
                                    key={index}
                                    sx={{
                                      fontSize: "14px",
                                      color: "#000",                    // Black text

                                      "@media (max-width: 700px)": {
                                        fontSize: "12px",
                                      },

                                      "@media (max-width: 450px)": {
                                        fontSize: "11px",
                                      },
                                    }}
                                  >
                                    {point}
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      ))}

                      <Grid sx={{ display: "flex", justifyContent: "center" }}>
                        <Button
                          variant="contained"
                          sx={{ borderRadius: "10px", background: "F3D45E", color: "#0B1420", textTransform: "capitalize", fontSize: "16px", fontWeight: "600", width: "180px", marginTop: "10px", marginBottom: "5px" }}
                          onClick={() => { handleProceedOption() }}
                        >
                          Proceed
                        </Button>
                      </Grid>

                    </Grid>
                  }


                  {
                    optionSelected == "Manual" &&
                    <>
                      <TxtField
                        sx={{ width: isSmallScreen ? "320px" : "350px" }}
                        type={showBankAcc ? "text" : "password"}
                        value={bankAccNo}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(/\D/g, "")
                          setBankAccNo(onlyNums)
                        }}
                        // onFocus={() => setShowBankAcc(true)}
                        onBlur={() => setShowBankAcc(false)}
                        error={baError}
                        helperText={baError && "Enter Bank Account Number"}
                        label="Bank Account Number*" // dev Srini - (12-03-25)
                        variant="outlined"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        InputLabelProps={{
                          style: { color: "#000000" },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => setShowBankAcc((prev) => !prev)}
                              >
                                <VisibilityIcon style={{ color: "#000" }} />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                      <br />

                      <TxtField
                        onPaste={(e) => e.preventDefault()}
                        sx={{ width: isSmallScreen ? "320px" : "350px" }}
                        value={bankAccNo1}
                        onChange={(e) => setBankAccNo1(e.target.value)}
                        error={ba1Error || match}
                        helperText={
                          (ba1Error && "Re-Enter Bank Account Nubmer") ||
                          (match && "Bank Account No. does not Match")
                        }
                        type="number" // srini (07-04-25)
                        label="Re-enter Account Number*"
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: "#000000" },
                        }}
                      />
                      <br />
                      <TxtField
                        sx={{ width: isSmallScreen ? "320px" : "350px" }}
                        value={ifscCode}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase()
                            setIfscCode(value)
                          }}
                        error={ifscError}
                        helperText={ifscError && "Enter Bank IFSC code"}
                        label="IFSC Code*"
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: "#000000" },
                        }}
                      />
                      <br />
                      <TxtField
                        sx={{ width: isSmallScreen ? "320px" : "350px" }}
                        value={bankUpi}
                        onChange={(e) => setBankUpi(e.target.value)}
                        error={bankUpi && bankUpiError}
                        helperText={bankUpi && bankUpiError && bankUpiValidationMsg}
                        label="Enter Bank Upi"
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: "#000000" },
                        }}
                      />
                      <FormGroup>
                        <FormControlLabel
                          sx={{
                            color: "black",
                            fontSize: "12px !important",
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                            },
                          }}
                          control={
                            <Checkbox
                              checked={primary}
                              onChange={() => setPrimary(!primary)}
                              sx={{
                                "& .MuiSvgIcon-fontSizeMedium": {
                                  color: "black",
                                },
                              }}
                            />
                          }
                          label="Set as primary"
                        />
                        <FormControlLabel
                          sx={{
                            color: "black",
                            alignItems: "flex-start",
                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                              paddingRight: "1.5%",
                            },
                          }}
                          control={
                            <Checkbox
                              checked
                              sx={{
                                "& .MuiSvgIcon-fontSizeMedium": {
                                  color: "black",
                                },
                                alignItems: "flex-start",
                              }}
                            />
                          }
                          label="I/We hereby declare that the above information provided by me, is true and to the best of my knowledge. I/We undertake to inform Triveni Management Consultancy Services Ltd. of any discrepancies, changes, or incorrect information that I become aware of, immediately. I/We understand that in case any information provided above is incorrect or misleading, I/We would be held liable for all such consequences/actions taken with respect to the above information. This change will affect the Trading and Demat account that I hold with Triveni Management Consultancy Services Ltd."
                        />
                      </FormGroup>

                      <Button sx={{ marginTop: "20px" }}
                        onClick={(e) => handleFormSubmit(e)}
                      >
                        <b>Submit</b>
                      </Button>

                    </>
                  }

                  {
                    (optionSelected == "RPD" && !isTabNMobile) &&

                      <Grid
                        sx={{
                          display: "flex", justifyContent: "center",
                          flexDirection: "column", alignItems: "center",
                        }}
                      >
                        {!primaryChosen ? (

                          // STEP 1 — ask about primary preference, THEN kick off QR generation
                          <PrimaryChoiceStep
                            onChoice={(wantsPrimary) => {
                              setPrimary(wantsPrimary);   // store their choice
                              dispatch(setPrimaryChosen(true))
                                handleHitRpd(wantsPrimary);         // ← your existing QR generation function
                            }}
                          />

                          ) : !showlodder && qrLink ? (

                          // STEP 2 — show QR once it's ready
                          <QRStep
                            qrLink={qrLink}
                            webTimeLeft={webTimeLeft}
                            primary={primary}
                          />

                        ) : (

                          // Loading state while QR is being fetched
                          <Typography sx={{ fontSize: "13px", color: "#7b6ea0", mt: 2 }}>
                            Generating QR code…
                          </Typography>

                        )}
                      </Grid>
                  }

                  {
                    (optionSelected == "RPD" && isTabNMobile) &&

                    <>

                      <Grid className={styles.payment_method_con}>
                          <Grid
                            className={styles.primary_checkbox_con}
                            onClick={(e) => e.stopPropagation()} // prevent triggering parent click
                          >
                            <Checkbox
                              checked={primary}
                              onChange={(e) => {
                                setPrimary(!primary);
                              }}
                              size="small"
                              sx={{ padding: "2px", color: "#000000" }}
                            />
                            <Typography className={styles.primary_label}>
                              Set as primary bank account
                            </Typography>
                          </Grid>
                        <Grid
                          item
                          xs={6}
                          className={`${styles.option} ${mobileSelectedOption === "PhonePe" ? styles.selected : ""
                            }`}
                          onClick={() => setMobileSelectedOption("PhonePe")}
                        >
                          <Grid className={styles.img_card1}>

                            <img src={phonepe} alt="bankLogo" />
                          </Grid>

                          <Typography className={styles.option_text}>
                            PhonePe
                          </Typography>

                          <CustomRadio
                            checked={mobileSelectedOption === "PhonePe"}
                            onChange={handleOptionChange}
                            value="PhonePe"
                            sx={{ marginLeft: 'auto' }}
                          />

                        </Grid>

                        <Grid
                          item
                          xs={6}
                          className={`${styles.option} ${mobileSelectedOption === "GPay" ? styles.selected : ""
                            }`}
                          onClick={() => setMobileSelectedOption("GPay")}
                        >
                          <Grid className={styles.img_card1}>

                            <img src={gpay} alt="upiLogo" />

                          </Grid>

                          <Typography className={styles.option_text}>
                            GPay
                          </Typography>

                          <CustomRadio
                            checked={mobileSelectedOption === "GPay"}
                            onChange={handleOptionChange}
                            value="GPay"
                            sx={{ marginLeft: 'auto' }}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          className={`${styles.option} ${mobileSelectedOption === "Paytm" ? styles.selected : ""
                            }`}
                          onClick={() => setMobileSelectedOption("Paytm")}
                        >
                          <Grid className={styles.img_card1}>

                            <img src={paytm} alt="upiLogo" />

                          </Grid>

                          <Typography className={styles.option_text}>
                            Paytm
                          </Typography>

                          <CustomRadio
                            checked={mobileSelectedOption === "Paytm"}
                            onChange={handleOptionChange}
                            value="Paytm"
                            sx={{ marginLeft: 'auto' }}
                          />
                        </Grid>


                        <Grid
                          item
                          xs={6}
                          className={`${styles.option} ${mobileSelectedOption === "manual" ? styles.selected : ""
                            }`}
                          onClick={() => setMobileSelectedOption("manual")}
                        >
                          <Grid className={styles.img_card1}>

                            <img src={banKicon} alt="upiLogo" />

                          </Grid>

                          <Typography className={styles.option_text}>
                            Add Bank Details Manually
                          </Typography>

                          <CustomRadio
                            checked={mobileSelectedOption === "manual"}
                            onChange={handleOptionChange}
                            value="manual"
                            sx={{ marginLeft: 'auto' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid sx={{
                        display: "flex", flexDirection: "column", gap: "10px", padding: "20px 0px 10px 0px ", justifyContent: "center",
                        alignItems: "center",

                      }}>

                        {
                          rpdError && <Typography className={styles.err_txt}>
                            {rpdError}
                          </Typography>
                        }

                        {
                          mobileSelectedOption !== "manual" && <Typography className={styles.rpd_txt1}>
                            <span style={{ fontFamily: "Inter700" }}>₹1</span> will be debited from your account to verify bank details.It will be refunded within 3 working days.
                          </Typography>
                        }



                        <Button
                          variant="contained"
                            sx={{ borderRadius: "10px", background: "F3D45E", color: "#241E41", textTransform: "capitalize", fontSize: "16px", fontWeight: "600", width: "200px" }}
                          onClick={handleMobileProceed}
                        >
                          {mobileSelectedOption == "manual" ? "Proceed" : "Send ₹1 to verify"}
                        </Button>
                      </Grid>
                    </>
                  }
                </Box>
              </Modal>
            )}

            <Modal
              open={dialog}
              disableBackdropClick={false}
              onClose={() => {
                setDialog(false);
                setShowLodder(false);
                if (
                  error == "Bank Account Added Successfully" ||
                  error == "Bank Upi Added Successfully"
                ) {
                  // dev Srini - (12-03-25)
                  window.location.reload();
                } else {
                  setError("");
                }
              }}
              sx={{ border: 'none' }}>
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: screen1000px ? '60%' : '50%',
                  // height: 'auto',
                  outline: 'none',
                  background: '#ffffff',
                  padding: "30px",
                  borderRadius: '8px',
                  // padding: '2%',
                  justifyContent: 'center', alignItems: 'center',
                  "@media only screen and (max-width: 850px)": {
                    width: '60%',
                  },
                  "@media only screen and (max-width: 650px)": {
                    width: '80%',
                  }
                }}
              >

                {/* ✅ Close Icon */}
                <IconButton
                  onClick={() => {
                    setDialog(false);
                    setShowLodder(false);
                    if (
                      error == "Bank Account Added Successfully" ||
                      error == "Bank Upi Added Successfully"
                    ) {
                      setIfscCode("")
                      setBankAccNo("")
                      setBankUpi("")
                      // dev Srini - (12-03-25)
                      window.location.reload();
                    } else {
                      setError("");
                    }
                  }}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: "#444",
                    zIndex: 10,
                  }}
                >
                  <CloseIcon />
                </IconButton>

                <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <img src={error === "Bank Account Added Successfully" ||
                    error == "Bank Upi Added Successfully" ? successIcon : errorIcon} alt={""} width={screen1000px ? '60px' : '80px'}></img>
                </Grid>
                <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
                  {error === "Bank Account Added Successfully" ||
                    error == "Bank Upi Added Successfully" ? <Typography className={styles1.payment_succ} sx={{
                      "@media only screen and (max-width: 600px)": {
                        fontSize: '21px !important'
                      }
                    }}>{error}</Typography> : <Typography className={styles1.payment_succ} sx={{
                      "@media only screen and (max-width: 600px)": {
                        fontSize: '21px !important'
                      }
                    }}>Failed To Add Bank Account</Typography>}
                  {error === "Bank Account Added Successfully" && <Typography className={styles1.payment_msg}>Account Number : {bankAccNo}</Typography>}
                  {error === "Bank Account Added Successfully" && <Typography className={styles1.payment_msg}>IFSC : {ifscCode}</Typography>}
                  {error === "Bank Account Added Successfully" && bankUpi?.trim()?.length > 0 && <Typography className={styles1.payment_msg}>UPI Id : {bankUpi}</Typography>}
                  {error !== "Bank Account Added Successfully" &&
                    error !== "Bank Upi Added Successfully" && <Typography className={styles1.payment_msg}>{error}</Typography>}
                </Grid>
              </Box>
            </Modal>

          </>

      }


      {/* Name Missmatch */}
      <Dialog
        open={dialogTwo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "12px",
            padding: 3,
            background: "#fff",
            maxWidth: "none",
            position: "relative"
          }
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: "#999",
          }}
          onClick={() => {
            setDialogTwo(false)
            setError("")
            setSelectedFileName("")
            setShowLodder(false)
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ color: '#000000', justifyContent: "center" }}>
          <Typography sx={{ textAlign: "center", fontSize: { xs: '21px', sm: '24px' } }}> Name Mismatch Error</Typography>
          <Typography sx={{ textAlign: "center", whiteSpace: "pre-line", color: "#9A9A9A", fontSize: { xs: '14px', sm: '16px' }, mt: 1 }}>
            {"We couldn't verify your bank account due to a name mismatch with Aadhaar or PAN.\n Kindly upload a cancelled cheque or passbook to continue."}
          </Typography>
        </DialogContent>

        <DialogTitle
          sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingBottom: 4 }}
          id="alert-dialog-title"
        >
          <Box
            sx={{
              border: '2px dashed #D3D3D3',
              borderRadius: '8px',
              padding: '16px 24px',
              width: 'fit-content',
              cursor: "pointer",
              fontSize: "14px",
              color: "#9A9A9A"
            }}
            onClick={() => document.getElementById('bank-upload').click()}
          >
            Drag and Drop here / {" "}
            <Typography component="span" sx={{ color: "#007BFF", fontWeight: 500 }}>
              Browse File
            </Typography>
          </Box>

          <input
            id="bank-upload"
            accept=".jpeg, .jpg, .png"
            type="file"
            hidden
            onChange={handleFileChange}
          />
          {selectedFileName && (
            <Typography sx={{ mt: 1, fontSize: "14px", color: "#4CAF50" }}>
              Selected File: {selectedFileName}
            </Typography>
          )}

          {error && (
            <Typography sx={{ mt: 1, fontSize: "14px", color: "red" }}>
              {error}
            </Typography>
          )}
        </DialogTitle>

        <DialogActions
          sx={{
            background: "#FFFFFF",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Button onClick={handleUploadToS3} sx={{ fontWeight: 600, borderRadius: '8px', width: '120px', textTransform: "capitalize" }}>continue</Button>
        </DialogActions>
      </Dialog>

      {/* File Upload Thanks card */}
      <Dialog
        open={dialogThree}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "12px",
            padding: 4,
            background: "#fff",
            maxWidth: "none"
          }
        }}
      >
        <DialogContent sx={{ color: '#000000', display: "flex", justifyContent: "center", paddingBottom: 0 }}>
          <Box
            component="img"
            src={fileUpload}
            sx={{
              width: { xs: 60, sm: 80 },
              height: { xs: 60, sm: 80 }
            }}
          />
        </DialogContent>

        <DialogContent sx={{ color: '#000000', justifyContent: "center", paddingBottom: 0, paddingTop: 1, }}>

          <Typography sx={{ textAlign: "center", fontSize: { xs: '24px', sm: '34px' } }}> Thanks! We've received your file. </Typography>
        </DialogContent>

        <DialogTitle
          sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingTop: 1, paddingBottom: 4 }}
          id="alert-dialog-title"
        >
          <Typography sx={{ textAlign: "center", whiteSpace: "pre-line", color: "#9A9A9A", fontSize: { xs: '16px', sm: '18px' } }}>
            {"We'll verify your bank details and update the status soon."}
          </Typography>
        </DialogTitle>

        <DialogActions
          sx={{
            background: "#FFFFFF",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Button onClick={() => {
            setDialogThree(false)
            setShowLodder(false)
          }} sx={{ fontWeight: 600, borderRadius: '8px', width: '120px', }}>ok</Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={openRpdModel}
        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // ❗ Block outside click close
          if (reason === "escapeKeyDown") return; // Optional
          dispatch(setRpdMsgModelToFalse());
        }}
        sx={{
          display: "flex",
          alignItems: "flex-end",     // Stick to bottom
          justifyContent: "center",
        }}
      >
        <Slide direction="up" in={openRpdModel} mountOnEnter unmountOnExit>
          <Box
            sx={{
              width: "100%",
              // maxWidth: "800px",
              bgcolor: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0px -4px 20px rgba(0,0,0,0.3)",
              p: 2,
              m: 2
            }}
          >

            {/* ----------- IMAGE FIRST ----------- */}
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <img
                src={MsgIcon}
                alt="modalIcon"
                style={{ width: "80px", height: "80px" }}
              />
            </Box>

            {/* ----------- TITLE ----------- */}

            <Typography sx={{
              textAlign: "center", mb: 1, color: "#E93333", fontWeight: "700", letterSpacing: "0px",
              fontSize: "18px",
              "@media (max-width: 400px)": {
                fontSize: "15px"
              }
            }}>
              FAILED TO ADD BANK ACCOUNT
            </Typography>
            {/* <Typography
              variant="h6"
              
              sx={{ textAlign: "center", fontFamily:"Inter700",letterSpacing:"0px",
                fontSize: "20px",
                marginBottom:"18px",
                "@media (max-width: 400px)": {
                  fontSize: "17px",
                  marginBottom: "15px"
                }
               }}
            >
             We could not verify your bank  account. Please try again
            </Typography> */}
            {
              rpdError &&
              <Typography
                sx={{
                  textAlign: "center", fontWeight: "700", letterSpacing: "0px",
                  fontSize: "20px",
                  color: "#000000",
                  marginBottom: "18px",
                  "@media (max-width: 400px)": {
                    fontSize: "17px",
                    marginBottom: "15px"
                  }
                }}
              >
                {rpdError}
                {/* NRO accounts are not supported for verification. Please provide an Indian resident savings or current bank account. */}
              </Typography>
            }

            {/* ----------- DESCRIPTION ----------- */}

            {/* ----------- BUTTON ----------- */}
            <Button
              variant="contained"
              fullWidth
              sx={{ borderRadius: "10px", background: "linear-gradient(90deg, #E93333 0%, #6A2066 100%)", color: "#ffffff", textTransform: "capitalize", fontSize: "16px", fontWeight: "700" }}
              onClick={() => { handleModelClose() }}
            >
              Retry
            </Button>

          </Box>
        </Slide>
      </Modal>
      <MyModal />

      <RpdErrorModal
        open={rpdErrorModal}
        onClose={() => setRpdErrorModal(false)}
      />
      <SimpleErrorModal
        open={errorModal}
        onClose={() =>{
          setErrorModal(false)
        }}
        msg={error}
      />

      <AccountSuccessModal
        open={successModal}
        onClose={() =>{
           setSuccessModal(false)
           window.location.reload();
        }
      }
      />
      <MyLodder canShow={showlodder} />
    </Container>
  );
};

export default Request;
